import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/issues/importer/issuesImporterActions';

export default importerReducers(actions);
